<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-intro" />
      <div class="portfolio-info">
        <div class="project">
          <p class="project-name">Rehabit</p>
          <p class="role">Product design</p>
          <p class="role">2021</p>
          <a href="https://apps.apple.com/app/id1473561369" target="_blank">
            <img src="/images/appstore.png" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.neofect.connect"
            target="_blank"
          >
            <img src="/images/googlestore.png" />
          </a>
        </div>
        <div class="members">
          <ul>
            <li><b>Company</b>: Neofect</li>
            <li><b>Industry</b>: Healthcare</li>
            <li><b>Strategy</b>: Patrick, Hyunjeong Noh, Soyoung Kim</li>
            <li><b>UX Design</b>: Yuri Ahn, Hyunjeong Noh</li>
            <li><b>UI/GUI Design</b>: Yuri Ahn</li>
            <li><b>Illustration</b>: Yuri Ahn</li>
            <li><b>Data Analysis</b>: Dokyeong Ha</li>
            <li><b>Product Development</b>: Dev. team</li>
          </ul>
        </div>
      </div>
      <div class="service-introduce">
        <img src="/images/portfolios/rehabit/01.png" alt="01" />
        <img src="/images/portfolios/rehabit/02.png" alt="02" />
        <rehabit-ani />
        <img src="/images/portfolios/rehabit/04.png" alt="04" />
        <img src="/images/portfolios/rehabit/05.png" alt="05" />
        <img src="/images/portfolios/rehabit/06.png" alt="06" />
        <div class="swiper">
          <swiper
            :slides-per-view="3"
            :space-between="10"
            :loop="true"
            :loopFillGroupWithBlank="true"
            :centered-slides="true"
            :autoplay="{
              delay: 1300,
              disableOnInteraction: false,
            }"
          >
            <swiper-slide>
              <img src="/images/portfolios/rehabit/img_st1.png" alt="img_st1" />
            </swiper-slide>
            <swiper-slide>
              <img src="/images/portfolios/rehabit/img_st2.png" alt="img_st2" />
            </swiper-slide>
            <swiper-slide>
              <img src="/images/portfolios/rehabit/img_st3.png" alt="img_st3" />
            </swiper-slide>
            <swiper-slide>
              <img src="/images/portfolios/rehabit/img_st4.png" alt="img_st4" />
            </swiper-slide>
            <swiper-slide>
              <img src="/images/portfolios/rehabit/img_st5.png" alt="img_st5" />
            </swiper-slide>
          </swiper>
        </div>
        <img src="/images/portfolios/rehabit/08.png" alt="08" />
        <img
          src="/images/portfolios/rehabit/09.png"
          alt="09"
          style="margin-top: -20px"
        />
        <img src="/images/portfolios/rehabit/10.png" alt="10" />
        <img src="/images/portfolios/rehabit/11.png" alt="11" />
        <img src="/images/portfolios/rehabit/12.png" alt="12" />
        <img src="/images/portfolios/rehabit/13.png" alt="13" />
        <img src="/images/portfolios/rehabit/14.png" alt="14" />
        <!-- <div class="header">
          <span class="title">서비스 소개</span>
          <span class="desc">
            Rehabit은 뇌졸중 환자가 스스로 자기 관리를 할 수 있도록 도와주는
            재활습관 형성 앱입니다.
          </span>
        </div>
        <div class="contents">
          <img
            src="/images/portfolios/rehabit/img_logo_rehabit_black.svg"
            alt="rehabit_logo"
          />
          <img
            class="subtitle"
            src="/images/portfolios/rehabit/rehabit_subtitle.svg"
            alt="rehabit_subtitle"
          />
        </div> -->
      </div>
    </div>
    <div class="move-btn">
      <!-- <span class="prev"><img src="/images/chevron-left.svg" />Previous</span> -->
      <span class="next" @click="move('telerehap')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import RehabitAni from './RehabitAni'
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay } from "swiper/core";
SwiperCore.use([Autoplay]);
import "swiper/swiper.scss";

export default {
  name: "DetailRehabit",
  components: { RehabitAni, Swiper, SwiperSlide },
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
@import "@/views/MoveBtn.scss";

.contents-wrapper {
  overflow-x: hidden;
}

.contents-body {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.contents-body .portfolio-intro {
  width: 100%;
  height: 750px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: url("/images/portfolios/rehabit/top.png");
}

.contents-body .portfolio-info {
  display: flex;
}

.contents-body .portfolio-info .project img {
  width: 140px;
  height: 47px;
  margin: 38px 14px 0 0;
}

.contents-body .portfolio-info .project {
  padding-left: 182px;
}

.contents-body .portfolio-info .project .project-name,
.role {
  font-weight: 600;
  font-style: normal;
}

.contents-body .portfolio-info .project .project-name {
  font-size: 32px;
  line-height: 25px;
}

.contents-body .portfolio-info .project .role {
  font-size: 13px;
  line-height: 8px;
  color: #606266;
}

.contents-body .portfolio-info .members {
  padding-right: 197px;
  margin-left: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
}

.contents-body .service-introduce {
  padding: 100px 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  img {
    width: 100%;
  }
}

// .contents-body .service-introduce .header {
//   display: flex;
//   .title {
//     font-weight: normal;
//     font-style: normal;
//     font-size: 13px;
//     line-height: 42px;
//     color: #313544;
//   }
//   .desc {
//     margin-left: 211px;
//     font-weight: normal;
//     font-style: normal;
//     font-size: 24px;
//     line-height: 44px;
//   }
// }

// .contents-body .service-introduce .contents {
//   display: flex;
//   padding-top: 200px;
//   flex-direction: column;
//   align-items: center;
// }

// .contents-body .service-introduce .contents img {
//   width: 590px;
//   height: 130px;
// }

// .contents-body .service-introduce .contents .subtitle {
//   margin-top: 90px;
// }

// .service-introduce .swiper {
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }

.swiper-container {
  // margin-top: 30px;
  width: 70%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  margin-top: 70px;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide.swiper-slide-active img {
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  filter: drop-shadow(10px 40px 200px rgba(0, 0, 0, 0.1));
}

.swiper-slide.swiper-slide-prev img {
  opacity: 0.3;
}

.swiper-slide.swiper-slide-next img {
  opacity: 0.3;
}

/* Mobiles */
@media (min-width: 320px) and (max-width: 480px) {
  .contents-body .portfolio-intro {
    height: 230px;
  }

  .contents-body .portfolio-info {
    display: flex;
    flex-direction: column;
  }

  .contents-body .portfolio-info .project {
    padding-left: 50px;
  }

  .contents-body .portfolio-info .project img {
    width: 70px;
    height: 23px;
    margin: 10px 14px 0 0;
  }

  .contents-body .portfolio-info .project .project-name {
    font-size: 18px;
    line-height: 15px;
  }

  .contents-body .portfolio-info .project .role {
    font-size: 12px;
    line-height: 8px;
  }


  .contents-body .portfolio-info .members {
    padding-right: 50px;
    margin-left: 10px;
    font-weight: 400;
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    color: #606266;
  }

  .contents-body .service-introduce {
    padding: 25px 0 0 0;
  }
}
</style>
